interface OmschrijvingOptionsProps {
  m2: boolean;
  lp: boolean;
  onM2Change: (checked: boolean) => void;
  onLpChange: (checked: boolean) => void;
}

/**
 * What the auto-built omschrijving carries onto the invoice. Both off by default
 * and not stored (work item vordering-lp-option-and-installer-photos); the text
 * logic itself lives in buildOmschrijving.
 */
export function OmschrijvingOptions({ m2, lp, onM2Change, onLpChange }: OmschrijvingOptionsProps) {
  const options = [
    { label: 'm² mee op factuur?', checked: m2, onChange: onM2Change },
    { label: 'LP mee op factuur?', checked: lp, onChange: onLpChange },
  ];
  return (
    <fieldset className="mt-2 flex flex-wrap gap-2">
      <legend className="sr-only">Op de factuur</legend>
      {options.map((o) => (
        <label
          key={o.label}
          className="flex cursor-pointer items-center gap-2 rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm font-semibold text-td-navy transition hover:border-td-blue has-[:checked]:border-td-blue has-[:checked]:bg-td-blue/5"
        >
          <input
            type="checkbox"
            checked={o.checked}
            onChange={(e) => o.onChange(e.target.checked)}
            className="h-4 w-4 accent-td-blue"
          />
          {o.label}
        </label>
      ))}
    </fieldset>
  );
}
